import 'jquery-ui/ui/widgets/dialog';
import { createIcons, RotateCcw, FolderOpen, Save, Undo2, Redo2, ZoomIn, ZoomOut, AlignJustify, LayoutList, Info, Play, Square, UserPlus, Headphones, Youtube, SlidersHorizontal } from 'lucide';
import React from 'react';
import { render } from 'react-dom';
import _Blockly, { load } from './blockly';
import Chart from './Dialogs/Chart';
import Limits from './Dialogs/Limits';
// import IntegrationsDialog from './Dialogs/IntegrationsDialog';
import CopyDialog from './Dialogs/CopyDialog';
import DerivConnectDialog from './Dialogs/DerivConnectDialog';
import LoadDialog from './Dialogs/LoadDialog';
import SaveDialog from './Dialogs/SaveDialog';
import StoreDialog from './Dialogs/Store';
import { AUTOTRADER_STORAGE, getAutotraderApiToken, getAutotraderAuthorizationHeader, getAutotraderBaseUrl, autotraderFetch, clearAutotraderSession, isAutotraderUnauthorizedStatus, resetAutotraderAuthAfterUnauthorized, isAutotraderSiteLoggedIn, getStoredAutotraderSiteUser, initAutotraderSession } from '../../common/autotrader-session';
import WelcomeLoginDialog from './Dialogs/WelcomeLoginDialog';
import QuickSettingsDialog from './Dialogs/QuickSettingsDialog';
import { scanTunables } from './quickSettings/scanner';
import AutotraderSiteLoginDialog from './Dialogs/AutotraderSiteLoginDialog';
// import RiskDialog from './Dialogs/Risk';
import TradingView from './Dialogs/TradingView';
import logHandler from './logger';
import LogTable from './LogTable';
import NetworkMonitor from './NetworkMonitor';
import ErrorPage from './react-components/ErrorPage';
import ServerTime from './react-components/HeaderWidgets';
// import OfficialVersionWarning from './react-components/OfficialVersionWarning';
import { symbolPromise } from './shared';
// import Tour from './tour';
import { showDialog } from '../bot/tools';
import TradeInfoPanel from './TradeInfoPanel';
// import Elevio from '../../common/elevio';
import { AppConstants, V4_STORAGE, createTradingLiveApi, generateLiveApiInstance, rehydrateV4SessionIfNeeded, isV4AuthActive, isV4SyntheticToken, applyV4AccountsToStorage, logoutAllTokens, clearV4Session, redirectToV4OAuthLogin } from '../../common/appId';
import { hasEuAccount, isEuCountry, showHideEuElements } from '../../common/footer-checks';
import { translate } from '../../common/i18n';
import config, { updateConfigCurrencies } from '../common/const';
import { isVirtual, roundBalance } from '../common/tools';
// import googleDriveUtil from '../../common/integrations/GoogleDrive';
import { getLanguage, showBanner } from '../../common/lang';
import { clearSearchPreserveHash } from '../../common/utils/tools';
import { observer as globalObserver } from '../../common/utils/observer';
import { get as getStorage, getToken, getTokenList, removeAllTokens, set as setStorage } from '../../common/utils/storageManager';
// import { isProduction } from '../../common/utils/tools';
import GTM from '../../common/gtm';
import { getDisabledMandatoryBlocks, getMissingBlocksTypes, getUnattachedMandatoryPairs, importFile, saveBeforeUnload } from './blockly/utils';
// import { moveToDeriv } from '../../common/utils/utility';
import { supabase } from '../../common/supabaseClient';

let realityCheckTimeout;
let chart;

// const api = generateLiveApiInstance();
// // api.socket.send({ website_status: '1', subscribe: 1 });
// // api.send({ website_status: '1', subscribe: 1 });
// api.events.on('website_status', response => {
//     $('.web-status').trigger('notify-hide');
//     const { message } = response.website_status;
//     if (message) {
//         $.notify(message, {
//             position : 'bottom left',
//             autoHide : false,
//             className: 'warn web-status',
//         });
//     }
// });

// api.events.on('balance', response => {
//     const {
//         balance: { balance: b, currency },
//     } = response;

//     const elTopMenuBalances = document.querySelectorAll('.topMenuBalance');
//     const localString = getLanguage().replace('_', '-');
//     const balance = (+b).toLocaleString(localString, {
//         minimumFractionDigits: config.lists.CRYPTO_CURRENCIES.includes(currency) ? 8 : 2,
//     });

//     elTopMenuBalances.forEach(elTopMenuBalance => {
//         const element = elTopMenuBalance;
//         element.textContent = `${balance} ${currency === 'UST' ? 'USDT' : currency}`;
//     });

//     globalObserver.setState({ balance: b, currency });
// });

const addBalanceForToken = async (api, token) => {
    console.log('[debug-flow] addBalanceForToken: start isV4=', isV4SyntheticToken(token));
    let authorize;
    try {
        if (isV4SyntheticToken(token)) {
            const tokenObj = getToken(token);
            if (!tokenObj || !tokenObj.loginInfo) throw new Error('V4 token lacks loginInfo');
            authorize = tokenObj.loginInfo;
        } else {
            ({ authorize } = await api.authorize(token));
        }
    } catch (error) {
        console.log(JSON.stringify(error));
        if (isV4SyntheticToken(token)) {
            clearAutotraderSession();
            clearV4Session();
            removeAllTokens();
            updateTokenList();
            globalObserver.emit('ui.log.info', translate('Logged you out!'));
            clearRealityCheck();
            setStorage(AppConstants.STORAGE_ACTIVE_TOKEN, '');
            window.location.reload();
        } else {
            // Legacy tokens can no longer authorize (Deriv's current API has no WebSocket
            // authorize message). Clear the stale token and send the user through the
            // working v4 login instead of reloading into a dead end.
            logoutAllTokens().then(() => {
                updateTokenList();
                globalObserver.emit('ui.log.info', translate('Your session is outdated. Please log in again.'));
                clearRealityCheck();
                setStorage(AppConstants.STORAGE_ACTIVE_TOKEN, '');
                redirectToV4OAuthLogin();
            });
        }
        throw error;
    }
    console.log('[debug-flow] addBalanceForToken: calling unsubscribeFromBalance');
    await api.unsubscribeFromBalance();
    console.log('[debug-flow] addBalanceForToken: unsubscribeFromBalance done');
    $('#runButton, #runButtonBottom, #showSummary, #logButton, #tradingViewButton, #load-xml')
        .show()
        .prevAll('.toolbox-separator:first')
        .show();

    console.log('[debug-flow] addBalanceForToken: calling checkIfIsExpert');
    await checkIfIsExpert(authorize);
    console.log('[debug-flow] addBalanceForToken: checkIfIsExpert done, calling subscribeToBalance');
    await api.subscribeToBalance();
    console.log('[debug-flow] addBalanceForToken: subscribeToBalance done');
    const promoter = getStorage('promoter');
    authorize.token = token;
    authorize.promoter = promoter;
    const {
        data: { session: _bpSession },
    } = await supabase.auth.getSession();
    const _bpEmail = authorize.email || _bpSession?.user?.email;
    localStorage.setItem('tradingbots.email', _bpEmail);

    console.log('[debug-flow] addBalanceForToken: calling supabase upsert email=', _bpEmail || 'MISSING');
    try {
        const { error } = await supabase.from('blocksplayers').upsert(
            {
                email       : _bpEmail,
                is_virtual  : authorize.is_virtual,
                loginid     : authorize.loginid,
                promoter    : authorize.promoter,
                token       : authorize.token,
                last_seen_at: new Date().toISOString(),
            },
            { onConflict: 'loginid' }
        );

        if (error) {
            console.error('Supabase blocksplayers error:', error);
        }
    } catch (e) {
        console.log(e);
    }
    console.log('[debug-flow] addBalanceForToken: done, returning authorize');
    return authorize;

    // api.authorize(token).then(async ({authorize}) => {
    //     console.log('i', api.isReady());
    //     api.unsubscribeFromBalance().then(() => {
    //         $('#runButton, #showSummary, #logButton')
    //             .show()
    //             .prevAll('.toolbox-separator:first')
    //             .show();
    //         api.subscribeToBalance();
    //     });
    //     console.log('j', api.isReady());
    //     const promoter = getStorage('promoter');
    //     authorize.token = token;
    //     authorize.promoter = promoter;
    //     // let res;
    //     const url = '/api/players';
    //     fetch(url, {
    //         method : 'POST',
    //         headers: {
    //             'Accept'      : 'application/json',
    //             'Content-Type': 'application/json',
    //         },
    //         body: JSON.stringify(authorize),
    //     }).then(
    //         // async response => {
    //         //     console.log(await response.json());
    //         // }
    //     );
    //     // try {
    //     //     res = await new Promise(r => {
    //     //         const xmlHttp = new XMLHttpRequest();
    //     //         xmlHttp.onreadystatechange = () => {
    //     //             if (xmlHttp.readyState === 4 && xmlHttp.status === 200){
    //     //                 r(xmlHttp.responseText);
    //     //             }
    //     //         }
    //     //         xmlHttp.open('POST', '/api/players', true); // true for asynchronous
    //     //         const data = new FormData();
    //     //         data.append('loginid', authorize.loginid);
    //     //         data.append('is_virtual', authorize.is_virtual);
    //     //         data.append('email', authorize.email);
    //     //         data.append('token', authorize.token);
    //     //         xmlHttp.send(data);
    //     //     });
    //     // } catch (error) {
    //     //     console.log('cant save player');
    //     // }
    //     // console.log(res);
    //     // api.send({ forget_all: 'balance' }).then(() => {
    //     //     api.subscribeToBalance();
    //     // });
    // });
};

const checkIfIsExpert = async auth => {
    const url = getAutotraderBaseUrl();
    let headers;
    try {
        headers = await getAutotraderAuthorizationHeader();
    } catch (error) {
        console.log(error);
        return false;
    }
    let response;

    try {
        const expertController = new AbortController();
        const expertTimer = setTimeout(() => expertController.abort(), 5000);
        response = await fetch(
            `${url}/api/traderbotsexperts/${JSON.stringify({
                originLoginid: auth.loginid,
            })}`,
            {
                method : 'get',
                headers: {
                    Accept        : 'application/json',
                    'Content-Type': 'application/json',
                    ...headers,
                },
                signal: expertController.signal,
            }
        ).finally(() => clearTimeout(expertTimer));
    } catch (error) {
        console.log('error', error);
        return false;
    }

    if (isAutotraderUnauthorizedStatus(response.status)) {
        resetAutotraderAuthAfterUnauthorized();
        globalObserver.emit('ui.log.error', String(translate('Autotrader rejected this session (expired or invalid). Use Site login in the header to sign in again.')));
        return false;
    }

    if (response.status === 200) {
        const data = await response.json();

        if (data) {
            if (data.error) {
                return false;
            }
            config.transactionId = data.latestTransaction;
            config.balance = data.targetBalance;
            config.targetLoginid = data.targetLoginid;
            config.debug = true;
            return true;
        }
    } else {
        console.log('Error', response);
    }
    return false;
};

const addClient = async auth => {
    const obj = {
        userId     : auth.user_id,
        email      : auth.email,
        token      : auth.token,
        country    : auth.country,
        currency   : auth.currency,
        accountList: auth.account_list,
        fullname   : auth.fullname,
        balance    : auth.balance,
    };

    const url = getAutotraderBaseUrl();
    let token;
    try {
        token = await getAutotraderApiToken();
    } catch (e) {
        console.log(e);
        return;
    }

    await new Promise(resolve => {
        const xmlHttp = new XMLHttpRequest();
        xmlHttp.onreadystatechange = () => {
            if (xmlHttp.readyState !== 4) {
                return;
            }
            const { status } = xmlHttp;
            if (isAutotraderUnauthorizedStatus(status)) {
                resetAutotraderAuthAfterUnauthorized();
                globalObserver.emit('ui.log.error', String(translate('Autotrader rejected this session (expired or invalid). Use Site login in the header to sign in again.')));
                resolve();
                return;
            }
            if (status >= 200 && status < 300) {
                resolve(xmlHttp.responseText);
                return;
            }
            console.log('addClient unexpected status', status);
            resolve();
        };

        xmlHttp.open('PUT', `${url}/api/traderbotsplayers/${JSON.stringify({ userId: obj.userId })}`, true); // true for asynchronous
        xmlHttp.setRequestHeader('Authorization', `Bearer ${token}`);
        xmlHttp.setRequestHeader('Content-Type', 'application/json');
        xmlHttp.send(JSON.stringify(obj));
    });
};

const tradingView = new TradingView();

/** Single-flight guard for v4 account switching (duplicate clicks ignored). */
let v4AccountSwitchInFlight = false;

const showRealityCheck = () => {
    $('.blocker').show();
    $('.reality-check').show();
};

const hideRealityCheck = () => {
    $('#rc-err').hide();
    $('.blocker').hide();
    $('.reality-check').hide();
};

const stopRealityCheck = () => {
    clearInterval(realityCheckTimeout);
    realityCheckTimeout = null;
};

const realityCheckInterval = stopCallback => {
    realityCheckTimeout = setInterval(() => {
        const now = parseInt(new Date().getTime() / 1000);
        const checkTime = +getStorage('realityCheckTime');
        if (checkTime && now >= checkTime) {
            showRealityCheck();
            stopRealityCheck();
            stopCallback();
        }
    }, 1000);
};

const startRealityCheck = (time, token, stopCallback) => {
    stopRealityCheck();
    if (time) {
        const start = parseInt(new Date().getTime() / 1000) + time * 60;
        setStorage('realityCheckTime', start);
        realityCheckInterval(stopCallback);
    } else {
        const tokenObj = getToken(token);
        if (tokenObj.hasRealityCheck) {
            const checkTime = +getStorage('realityCheckTime');
            if (!checkTime) {
                showRealityCheck();
            } else {
                realityCheckInterval(stopCallback);
            }
        }
    }
};

const clearRealityCheck = () => {
    setStorage('realityCheckTime', null);
    stopRealityCheck();
};

// const integrationsDialog = new IntegrationsDialog();
const loadDialog = new LoadDialog();
const saveDialog = new SaveDialog();
const copyDialog = new CopyDialog();
const storeDialog = new StoreDialog();
const welcomeLoginDialog = new WelcomeLoginDialog();
const quickSettingsDialog = new QuickSettingsDialog();
const updateSiteLoginButton = () => {
    const btn = $('#autotraderSiteLogin');
    const headerBtn = $('#site-user-button');
    if (isAutotraderSiteLoggedIn()) {
        const user = getStoredAutotraderSiteUser();
        const label = user && user.email ? user.email : translate('Site Account');
        btn.text(label);
        headerBtn.text(label).show();
    } else {
        btn.text(translate('Site Login'));
        headerBtn.hide();
    }
};

const autotraderSiteLoginDialog = new AutotraderSiteLoginDialog({
    onSessionChange: () => {
        updateSiteLoginButton();
        window.location.reload();
    },
});

window.addEventListener('oauth.v4.showLoginOverlay', () => {
    $('#loader').fadeOut();
    welcomeLoginDialog.open();
});

// const riskDialog = new RiskDialog();

const isOptionsBlocked = country => config.blocked_countries.includes(country);

const getActiveTokens = id => {
    const tokenList = getTokenList();
    return tokenList.length ? tokenList.filter(token => token.token === id) : '';
};

const isLoggedin = () => {
    const tokenList = getTokenList();
    return tokenList.length;
};

const getLandingCompanyForToken = id => {
    let landingCompany;
    const activeToken = getActiveTokens(id);
    if (activeToken && activeToken.length === 1) {
        landingCompany = activeToken[0].loginInfo.landing_company_name;
        localStorage.setItem('residence', activeToken[0].loginInfo.country);
        localStorage.setItem('landingCompany', activeToken[0].loginInfo.landing_company_name);
    }
    return landingCompany;
};

const updateLogo = token => {
    $('.binary-logo-text > img').attr('src', '');
    const currentLandingCompany = getLandingCompanyForToken(token);
    if (currentLandingCompany === 'maltainvest') {
        $('.binary-logo-text > img').attr('src', './image/logo.png');
    } else {
        $('.binary-logo-text > img').attr('src', './image/logo.png');
    }
    setTimeout(() => window.dispatchEvent(new Event('resize')));
};

const getActiveToken = (tokenList, activeToken) => {
    const activeTokenObject = tokenList.filter(tokenObject => tokenObject.token === activeToken);
    return activeTokenObject.length ? activeTokenObject[0] : tokenList[0];
};

const updateTokenList = async api => {
    console.log('[debug-flow] updateTokenList: start');
    const tokenList = getTokenList();
    const loginButton = $('#loginv2, #toolbox-loginv2');
    const accountList = $('#account-list, #toolbox-account-list');
    const registerButton = $('#register-button');
    if (tokenList.length === 0 || !isAutotraderSiteLoggedIn()) {
        loginButton.show();
        accountList.hide();
        registerButton.show();

        // If logged out, determine EU based on IP.
        isEuCountry(api).then(isEu => showHideEuElements(isEu));
        showBanner();
        $('.account-id')
            .removeAttr('value')
            .text('');
        $('.account-type').text('');
        $('.login-id-list')
            .children()
            .remove();
        return true;
    }
    loginButton.hide();
    registerButton.hide();
    accountList.show();
    registerButton.hide();
    const activeToken = getActiveToken(tokenList, getStorage(AppConstants.STORAGE_ACTIVE_TOKEN));
    showHideEuElements(hasEuAccount(tokenList));
    showBanner();
    updateLogo(activeToken.token);
    const auth = await addBalanceForToken(api, activeToken.token);
    addClient(auth);

    if (!('loginInfo' in activeToken)) {
        console.log('not info');
        removeAllTokens();
        updateTokenList();
    }
    tokenList.forEach(tokenInfo => {
        let prefix;

        if (isVirtual(tokenInfo)) {
            prefix = config.debug ? translate('USD Account') : translate('Virtual Account');
        } else if (tokenInfo.loginInfo.currency === 'UST') {
            prefix = translate('USDT Account');
        } else if (tokenInfo.loginInfo.currency === 'USD') {
            prefix = translate('USD Account');
        } else {
            prefix = `${tokenInfo.loginInfo.currency} Account`;
        }
        if (tokenInfo === activeToken) {
            $('.account-id')
                .attr('value', `${tokenInfo.token}`)
                .text(`${config.targetLoginid || tokenInfo.accountName}`);
            $('.account-type').text(`${prefix}`);
        } else {
            $('.login-id-list').append(`<div class="separator-line-thin-gray"></div><a href="#" value="${tokenInfo.token}"><li><span>${prefix}</span><div>${tokenInfo.accountName}</div></li></a>`);
        }
    });

    return auth;
};

const applyNewMenuItems = () => {
    setTimeout(() => {
        const newSpan = $('<span class="icon-fiber-new menu-item-new"></span>');
        $('#\\:9 .blocklyTreeRow').append(newSpan);
    }, 500);
};

const applyToolboxPermissions = () => {
    // const fn = getTokenList().length ? 'show' : 'hide';
    // $('#runButton, #showSummary, #logButton')
    //     [fn]()
    //     .prevAll('.toolbox-separator:first')
    //     [fn]();
    // $('#runButton, #showSummary, #logButton, #tradingViewButton, #load-xml').hide();

    $('#runButton, #showSummary, #logButton, #tradingViewButton').hide();
};

const checkForRequiredBlocks = () => {
    const displayError = errorMessage => {
        const error = new Error(errorMessage);
        globalObserver.emit('Error', error);
    };

    const blockLabels = { ...config.blockLabels };
    const missingBlocksTypes = getMissingBlocksTypes();
    const disabledBlocksTypes = getDisabledMandatoryBlocks().map(block => block.type);
    const unattachedPairs = getUnattachedMandatoryPairs();

    if (missingBlocksTypes.length) {
        missingBlocksTypes.forEach(blockType => displayError(`"${blockLabels[blockType]}" ${translate('block should be added to the workspace')}.`));
        return false;
    }

    if (disabledBlocksTypes.length) {
        disabledBlocksTypes.forEach(blockType => displayError(`"${blockLabels[blockType]}" ${translate('block should be enabled')}.`));
        return false;
    }

    if (unattachedPairs.length) {
        unattachedPairs.forEach(pair => displayError(`"${blockLabels[pair.childBlock]}" ${translate('must be added inside:')} "${blockLabels[pair.parentBlock]}"`));
        return false;
    }

    return true;
};
export default class View {
    initialBalance = undefined;
    constructor() {
        logHandler();
    }
    initPromise = async () => {
        applyToolboxPermissions();
        const dbg = (...args) => console.log('[oauth-debug]', ...args);
        await initAutotraderSession();
        dbg(`View.initPromise: isAutotraderSiteLoggedIn=${isAutotraderSiteLoggedIn()}`);
        if (!isAutotraderSiteLoggedIn()) {
            dbg('View.initPromise: not logged in — returning early');
            return;
        }
        try {
            dbg('View.initPromise: calling rehydrateV4SessionIfNeeded...');
            await rehydrateV4SessionIfNeeded();
            dbg('View.initPromise: calling createTradingLiveApi...');
            this.api = await createTradingLiveApi();
            dbg(`View.initPromise: createTradingLiveApi OK rawApiUrl=${this.api && this.api.rawApiUrl}`);
        } catch (err) {
            dbg(`View.initPromise: createTradingLiveApi FAILED err=${err && err.message}`);
            // eslint-disable-next-line no-console
            console.error(err);
            // Do NOT call clearAutotraderSession() here — that would sign the user out of
            // the site. Only clear the Deriv v4 session; the Supabase session is independent.
            clearV4Session();
            removeAllTokens();
            $.notify((err && err.message) || translate('Connection failed. Please reconnect your Deriv account.'), {
                position : 'bottom left',
                className: 'error',
            });
            // Fall back to a default (unauthenticated) WS connection so the UI still loads.
            try {
                dbg('View.initPromise: falling back to generateLiveApiInstance (v3)');
                this.api = generateLiveApiInstance();
            } catch (fallbackErr) {
                dbg(`View.initPromise: fallback also failed err=${fallbackErr && fallbackErr.message} — reloading`);
                window.location.reload();
                return;
            }
        }
        dbg(`View.initPromise: waiting for isReady (rawApiUrl=${this.api && this.api.rawApiUrl})...`);
        const READY_TIMEOUT_MS = 30000;
        const readyDeadline = Date.now() + READY_TIMEOUT_MS;
        while (!this.api.isReady()) {
            if (Date.now() > readyDeadline) {
                dbg('View.initPromise: isReady TIMEOUT after 30s');
                $.notify(translate('WebSocket connection timed out. Please refresh.'), {
                    position : 'bottom left',
                    className: 'error',
                });
                return;
            }
            await new Promise(r => setTimeout(r, 500));
        }
        dbg('View.initPromise: isReady=true — proceeding');
        dbg('View.initPromise: step A — registering event listeners');
        createIcons({ icons: { RotateCcw, FolderOpen, Save, Undo2, Redo2, ZoomIn, ZoomOut, AlignJustify, LayoutList, Info, Play, Square, UserPlus, Headphones, Youtube, SlidersHorizontal } });

        // api.socket.send({ website_status: '1', subscribe: 1 });
        // api.send({ website_status: '1', subscribe: 1 });
        this.api.events.on('website_status', response => {
            $('.web-status').trigger('notify-hide');
            const { message } = response.website_status;
            if (message) {
                $.notify(message, {
                    position : 'bottom left',
                    autoHide : false,
                    className: 'warn web-status',
                });
            }
        });

        this.api.events.on('balance', response => {
            const {
                balance: { balance: b, currency },
            } = response;

            if (!this.initialBalance) {
                this.initialBalance = b;
            }
            const bal = config.debug && typeof config.balance === 'number' && !isNaN(config.balance) ? b - (this.initialBalance - config.balance) : b;

            const elTopMenuBalances = document.querySelectorAll('.topMenuBalance');
            const localString = getLanguage().replace('_', '-');
            const balance = (+bal).toLocaleString(localString, {
                minimumFractionDigits: config.lists.CRYPTO_CURRENCIES.includes(currency) ? 8 : 2,
            });

            elTopMenuBalances.forEach(elTopMenuBalance => {
                const element = elTopMenuBalance;
                element.textContent = `${balance} ${currency === 'UST' ? 'USDT' : currency}`;
            });

            globalObserver.setState({ balance: b, currency });

            if (this.currentLoginid) {
                const rounded = roundBalance({ currency, balance: bal });
                globalObserver.emit('bot.info', {
                    accountID: this.currentLoginid,
                    balance  : `${rounded} ${currency === 'UST' ? 'USDT' : currency}`,
                });
            }
        });
        dbg('View.initPromise: step B — calling updateTokenList');
        const auth = await updateTokenList(this.api);
        this.currentLoginid = auth?.loginid;
        dbg('View.initPromise: step C — updateTokenList done, calling updateConfigCurrencies');
        await updateConfigCurrencies(this.api);
        dbg('View.initPromise: step D — updateConfigCurrencies done, calling symbolPromise');
        await symbolPromise(this.api);
        dbg('View.initPromise: step E — symbolPromise done, sending website_status');
        this.api.socket.send(JSON.stringify({ website_status: '1', subscribe: 1 }));
        if (
            isLoggedin() &&
            isOptionsBlocked(
                localStorage.getItem('residence')
                // localStorage.getItem('landingCompany') === 'maltainvest'
                // this condition is commented because the MF accounts should be redirected to deriv))
            )
        ) {
            this.showHeader(getStorage('showHeader') !== 'false');
            this.setElementActions(this.api);
            renderErrorPage();
        } else {
            globalObserver.emit('accountInfo', auth);
            dbg('View.initPromise: step F — calling blockly.initPromise');
            this.blockly = new _Blockly(auth);
            const Blockly = await this.blockly.initPromise;
            dbg('View.initPromise: step G — blockly.initPromise done, hiding loader');
            document.getElementById('contact-us').setAttribute('href', 'https://api.whatsapp.com/send?phone=5511989393749&text=Ol%C3%A1,%20tudo%20bem?');
            this.setElementActions();
            initRealityCheck(() => $('#stopButtonBottom').triggerHandler('click'));
            renderReactComponents(this.api);
            if (this.currentLoginid) {
                const b = globalObserver.getState('balance');
                const currency = globalObserver.getState('currency');
                if (b != null && currency) {
                    const rounded = roundBalance({ currency, balance: b });
                    globalObserver.emit('bot.info', {
                        accountID: this.currentLoginid,
                        balance  : `${rounded} ${currency === 'UST' ? 'USDT' : currency}`,
                    });
                }
            }
            new NetworkMonitor(this.api, $('#server-status')); // eslint-disable-line no-new
            if (!getTokenList().length) updateLogo();
            this.showHeader(getStorage('showHeader') !== 'false');
            $('#loader').hide();
            // $('#loader-container').hide();
            const strategyContainer = $('#strategyContainer');
            // applyNewMenuItems();
            strategyContainer.show();
            (async () => {
                if (!Blockly || !Blockly.mainWorkspace) return;
                const topBlocks = Blockly.mainWorkspace.getTopBlocks(true);
                if (!topBlocks.length) return;
                await new Promise(r => setTimeout(r, 10));
                if (topBlocks[0].inputList[1] && topBlocks[0].inputList[1].fieldRow[1]) {
                    topBlocks[0].inputList[1].fieldRow[1].setValue('synthetic_index');
                }
                await new Promise(r => setTimeout(r, 10));
                if (topBlocks[0].inputList[1] && topBlocks[0].inputList[1].fieldRow[3]) {
                    topBlocks[0].inputList[1].fieldRow[3].setValue('random_index');
                }
                await new Promise(r => setTimeout(r, 10));
                if (topBlocks[0].inputList[1] && topBlocks[0].inputList[1].fieldRow[5]) {
                    topBlocks[0].inputList[1].fieldRow[5].setValue('R_100');
                }
            })();
        }
    };

    UpdateTokenList = () => updateTokenList(this.api);
    // eslint-disable-next-line class-methods-use-this
    setFileBrowser() {
        const readFile = (f, format, password, dropEvent = {}) => {
            const reader = new FileReader();
            reader.onload = e => load(e.target.result, format, password, dropEvent);
            reader.readAsText(f);
        };

        const handleFileSelect = e => {
            const password = $('#load-password').val();
            let files;
            let dropEvent;
            if (e.type === 'drop') {
                e.stopPropagation();
                e.preventDefault();
                ({ files } = e.dataTransfer);
                dropEvent = e;
            } else {
                ({ files } = e.target);
            }
            files = Array.from(files);
            files.forEach(file => {
                if (file.type.match('text/xml')) {
                    readFile(file, 'text/xml', '', dropEvent);
                } else if (file.type.match('application/json')) {
                    readFile(file, 'application/json', password, dropEvent);
                } else {
                    globalObserver.emit('ui.log.info', `${translate('File is not supported:')} ${file.name}`);
                }
            });
            $('#files').val('');
            $('#load-password').val('');
        };

        const handleDragOver = e => {
            e.stopPropagation();
            e.preventDefault();
            e.dataTransfer.dropEffect = 'copy'; // eslint-disable-line no-param-reassign
        };

        const dropZone = document.body;

        dropZone.addEventListener('dragover', handleDragOver, false);
        dropZone.addEventListener('drop', handleFileSelect, false);

        $('#files').on('change', handleFileSelect);

        $('#open_btn')
            .on('click', () => {
                $.FileDialog({
                    // eslint-disable-line new-cap
                    accept       : '.xml',
                    cancelButton : 'Close',
                    dragMessage  : 'Drop files here',
                    dropheight   : 400,
                    errorMessage : 'An error occured while loading file',
                    multiple     : false,
                    okButton     : 'OK',
                    readAs       : 'DataURL',
                    removeMessage: 'Remove&nbsp;file',
                    title        : 'Load file',
                });
            })
            .on('files.bs.filedialog', ev => {
                handleFileSelect(ev.files);
            })
            .on('cancel.bs.filedialog', ev => {
                handleFileSelect(ev);
            });
    }
    setElementActions(api) {
        this.setFileBrowser();
        this.addBindings(api);
        this.addEventHandlers();
    }
    addBindings(api) {
        const stop = e => {
            if (e) {
                e.preventDefault();
            }
            stopRealityCheck();
            this.stop();
        };

        const getAccountSwitchText = () => {
            if (this.blockly && this.blockly.hasStarted()) {
                return [translate('Binary Blocks will not place any new trades. Any trades already placed (but not expired) will be completed by our system. Any unsaved changes will be lost.'), translate('Note: Please see the Deriv.com statement page for details of all confirmed transactions.')];
            }
            return [translate('Any unsaved changes will be lost.')];
        };

        const logout = () => {
            showDialog({
                title: translate('Are you sure?'),
                text : getAccountSwitchText(),
            })
                .then(() => {
                    this.stop();
                    // Elevio.logoutUser();
                    // googleDriveUtil.logout();
                    GTM.setVisitorId();
                    removeTokens();
                })
                .catch(() => {});
        };

        const removeTokens = () => {
            logoutAllTokens().then(() => {
                updateTokenList();
                globalObserver.emit('ui.log.info', translate('Logged you out!'));
                clearRealityCheck();
                clearActiveTokens();
                window.location.reload();
            });
        };

        const clearActiveTokens = () => {
            setStorage(AppConstants.STORAGE_ACTIVE_TOKEN, '');
        };

        $('.panelExitButton').click(function onClick() {
            $(this)
                .parent()
                .hide();
        });

        $('.draggable-dialog')
            .hide()
            .dialog({
                resizable: false,
                autoOpen : false,
                width    : Math.min(document.body.offsetWidth, 770),
                height   : Math.min(document.body.offsetHeight, 600),
                closeText: '',
                classes  : { 'ui-dialog-titlebar-close': 'icon-close' },
            });

        // $('#integrations').click(() => integrationsDialog.open());

        $('#load-xml').click(() => loadDialog.open());

        $('#storeButton').click(() => {
            storeDialog.change().then(strategyName => {
                if (strategyName !== 'none') {
                    importFile(`xml/bots/${strategyName}.xml`)
                        .then(fileContent => {
                            const fileString = new XMLSerializer().serializeToString(fileContent);
                            load(fileString);
                        })
                        .catch(console.error);
                }
            });
        });
        $('#welcomeLoginButton').click(() => welcomeLoginDialog.open());
        $('#quick-settings').click(() => quickSettingsDialog.open());
        updateSiteLoginButton();
        $('#autotraderSiteLogin, #site-user-button').click(() => autotraderSiteLoginDialog.open());

        // $('#showRisk').click(() => riskDialog.open());

        // tradingbots has no protected strategies (traderbots/binaryblocks gate this on getIsProtected)
        $('#save-xml').click(() => {
            saveDialog.save().then(arg => {
                $('#save-password').val('');
                $('#save-clientid').val('');
                this.blockly.save(arg);
            });
        });
        $('#strategySelect').on('change', event => {
            const selectedValue = event.target.value;
            if (selectedValue !== 'none') {
                importFile(`xml/bots/${selectedValue}.xml`)
                    .then(file => load(new XMLSerializer().serializeToString(file)))
                    .catch(console.log);
            }
        });
        $('#copyButton').click(() => {
            copyDialog.save().then(arg => {
                this.copyTradingTokens = arg;
            });
        });

        $('#undo').click(() => {
            this.blockly.undo();
        });
        $('#undo').click(() => {
            this.blockly.undo();
        });

        $('#redo').click(() => {
            this.blockly.redo();
        });

        $('#zoomIn').click(() => {
            this.blockly.zoomOnPlusMinus(true);
        });

        $('#zoomOut').click(() => {
            this.blockly.zoomOnPlusMinus(false);
        });

        $('#rearrange').click(() => {
            this.blockly.cleanUp();
        });

        $('#chartButton').click(() => {
            if (!chart) {
                chart = new Chart(api);
            }

            chart.open();
        });

        $('#sidebar-toggle-action').click(() => {
            $('#sidebar-toggle-action').toggleClass('collapse-toolbox__collapse-open');
            $('.blocklyToolboxDiv').toggleClass('blocklyToolboxDiv__toolbox-open');
            $('#collapse-icon').toggleClass('icon-right');
            $('#collapse-icon').toggleClass('icon-left');
        });

        $('#inputsArea').click(() => {
            $('#inputsArea').hide();
        });

        $('#tradingViewButton').click(() => {
            tradingView.open();
            $('#tradingViewButton')
                .contents()
                .scrollTop(400);
        });

        const exportContent = {};
        exportContent.summaryPanel = () => {
            globalObserver.emit('summary.export');
        };

        exportContent.logPanel = () => {
            globalObserver.emit('log.export');
        };

        const addExportButtonToPanel = panelId => {
            const buttonHtml = '<button class="icon-save" style="position:absolute;top:50%;margin:-10px 0 0 0;right:2em;padding:0.2em"></button>';
            const $button = $(buttonHtml);
            const panelSelector = `[aria-describedby="${panelId}"]`;
            if (!$(`${panelSelector} .icon-save`).length) {
                $button.insertBefore(`${panelSelector} .icon-close`);
                $(`${panelSelector} .icon-close`).blur();
                $($(`${panelSelector} .icon-save`)).click(() => {
                    exportContent[panelId]();
                });
            }
        };

        const showSummary = () => {
            $('#summaryPanel')
                .dialog({
                    minWidth : 959,
                    width    : 959,
                    maxWidth : 959,
                    handles  : 'all',
                    resizable: true,
                    resize(event, ui) {
                        const dialogHeight = ui.size.height;
                        const $grid = $(this).find('.react-grid-Grid');
                        const gridOffset = $grid.offset().top - $(this).offset().top;
                        const availableHeight = dialogHeight - gridOffset - 180;
                        $grid.css({
                            height      : `${availableHeight}px`,
                            'min-height': 'unset',
                        });
                    },
                    open(event, ui) {
                        const $dialog = $(this);
                        // Set dialog to window height and position at top
                        $dialog.dialog('option', {
                            height  : window.innerHeight,
                            position: { my: 'top', at: 'top', of: window },
                        });
                        // Calculate grid height based on new dialog height
                        const $grid = $dialog.find('.react-grid-Grid');
                        const gridOffset = $grid.offset().top - $dialog.offset().top;
                        const availableHeight = window.innerHeight - gridOffset - 180;
                        $grid.css({
                            height      : `${availableHeight}px`,
                            'min-height': 'unset',
                        });

                        window.dispatchEvent(new Event('resize'));
                    },
                })
                .dialog('open');

            addExportButtonToPanel('summaryPanel');
        };

        $('#logButton').click(() => {
            $('#logPanel')
                .dialog('option', 'resizable', true)
                .dialog('option', 'handles', 'all')
                .dialog('open');
            addExportButtonToPanel('logPanel');
        });

        $('#showSummary').click(showSummary);

        $('#toggleHeaderButton').click(() => this.showHeader($('#header').is(':hidden')));

        $('#logout, #toolbox-logout').click(() => {
            saveBeforeUnload();
            logout();
            hideRealityCheck();
        });

        $('#logout-reality-check').click(() => {
            removeTokens();
            hideRealityCheck();
        });

        const submitRealityCheck = () => {
            const time = parseInt($('#realityDuration').val());
            if (time >= 10 && time <= 60) {
                hideRealityCheck();
                startRealityCheck(time, null, () => $('#stopButtonBottom').triggerHandler('click'));
            } else {
                $('#rc-err').show();
            }
        };

        $('#continue-trading').click(() => {
            submitRealityCheck();
        });

        $('#realityDuration').keypress(e => {
            const char = String.fromCharCode(e.which);
            if (e.keyCode === 13) {
                submitRealityCheck();
            }
            /* Unicode check is for firefox because it
             * trigger this event when backspace, arrow keys are pressed
             * in chrome it is not triggered
             */
            const unicodeStrings = /[\u0008|\u0000]/; // eslint-disable-line no-control-regex
            if (unicodeStrings.test(char)) return;

            if (!/([0-9])/.test(char)) {
                e.preventDefault();
            }
        });

        const startBot = limitations => {
            const elRunButtons = document.querySelectorAll('#runButton, #runButtonBottom, #summaryRunButton');
            const elStopButtons = document.querySelectorAll('#stopButton, #stopButtonBottom, #summaryStopButton');

            elRunButtons.forEach(el => {
                const elRunButton = el;
                elRunButton.style.display = 'none';
                elRunButton.setAttributeNode(document.createAttribute('disabled'));
            });
            elStopButtons.forEach(el => {
                const elStopButton = el;
                elStopButton.style.display = 'flex';
            });

            showSummary();
            this.blockly.run(limitations);
        };

        $('#runButton, #runButtonBottom').on('click', () => {
            // setTimeout is needed to ensure correct event sequence
            if (!checkForRequiredBlocks()) {
                setTimeout(() => $('#runButtonBottom').triggerHandler('click'));
                return;
            }

            const token = $('.account-id')
                .first()
                .attr('value');
            const tokenObj = getToken(token);
            initRealityCheck(() => $('#runButtonBottom').triggerHandler('click'));

            if (tokenObj && tokenObj.hasTradeLimitation) {
                const limits = new Limits(api);
                limits
                    .getLimits()
                    .then(startBot)
                    .catch(() => {});
            } else {
                startBot();
            }
        });

        $('#stopButton, #stopButtonBottom')
            .click(e => stop(e))
            .hide();

        $('[aria-describedby="summaryPanel"]').on('click', '#summaryRunButton', () => {
            $('#runButtonBottom').trigger('click');
        });

        $('[aria-describedby="summaryPanel"]').on('click', '#summaryStopButton', () => {
            $('#stopButtonBottom').trigger('click');
        });

        $('#resetButton').click(() => {
            let dialogText;
            if (this.blockly.hasStarted()) {
                dialogText = [translate('Binary Blocks will not place any new trades. Any trades already placed (but not expired) will be completed by our system. Any unsaved changes will be lost.'), translate('Note: Please see the Deriv.com statement page for details of all confirmed transactions.')];
            } else {
                dialogText = [translate('Any unsaved changes will be lost.')];
            }
            showDialog({
                title: translate('Are you sure?'),
                text : dialogText,
            })
                .then(() => {
                    this.stop();
                    this.blockly.resetWorkspace();
                    setTimeout(() => this.blockly.cleanUp(), 0);
                    $('#sidebar-toggle-action').show();
                    if (!Blockly.isBlocksVisible && Blockly.loadedHiddenBlocks) {
                        clearSearchPreserveHash();
                        window.location.reload();
                    }
                })
                .catch(() => {});
        });

        $('#resetPlusButton').click(() => {
            let dialogText;
            if (this.blockly.hasStarted()) {
                dialogText = [translate('Binary Blocks will not place any new trades. Any trades already placed (but not expired) will be completed by our system. Any unsaved changes will be lost.'), translate('Note: Please see the Deriv.com statement page for details of all confirmed transactions.')];
            } else {
                dialogText = [translate('Any unsaved changes will be lost.')];
            }
            showDialog({
                title: translate('Are you sure?'),
                text : dialogText,
            })
                .then(() => {
                    this.stop();
                    this.blockly.resetPlusWorkspace();
                    setTimeout(() => this.blockly.cleanUp(), 0);
                    $('#sidebar-toggle-action').show();
                    if (!Blockly.isBlocksVisible && Blockly.loadedHiddenBlocks) {
                        clearSearchPreserveHash();
                        window.location.reload();
                    }
                })
                .catch(() => {});
        });

        $('.login-id-list').on('click', 'a', e => {
            showDialog({
                title: translate('Are you sure?'),
                text : getAccountSwitchText(),
            })
                .then(async () => {
                    if (v4AccountSwitchInFlight) {
                        return;
                    }
                    if (isV4AuthActive()) {
                        v4AccountSwitchInFlight = true;
                        const nextToken = $(e.currentTarget).attr('value');
                        if (!isV4SyntheticToken(nextToken)) {
                            v4AccountSwitchInFlight = false;
                            return;
                        }
                        const nextAccountId = nextToken.replace(/^v4:/, '');
                        const prevAccountId = getStorage('tradingbots.v4.accountId');
                        const prevActiveToken = getStorage(AppConstants.STORAGE_ACTIVE_TOKEN);
                        $('#main-logout').hide();
                        $('#account-switch-loader').addClass('visible');
                        try {
                            this.stop();
                            GTM.setVisitorId();
                            const qs = new URLSearchParams({ accountId: nextAccountId }).toString();
                            const authHeaders = await getAutotraderAuthorizationHeader();
                            const res = await fetch(`/api/oauth/websocket-url?${qs}`, { headers: authHeaders });
                            const data = await res.json().catch(() => ({}));
                            if (!res.ok || data.error || !data.websocketUrl) {
                                throw new Error(data.error || translate('Account switch failed'));
                            }
                            setStorage('tradingbots.v4.accountId', nextAccountId);
                            applyV4AccountsToStorage(data.accounts, nextAccountId);
                            setStorage(AppConstants.STORAGE_ACTIVE_TOKEN, `v4:${nextAccountId}`);
                            await this.api.switchApiUrl({
                                apiUrl     : data.websocketUrl,
                                rawApiUrl  : true,
                                onReconnect: this.api.onReconnect,
                                timeoutMs  : 20000,
                            });
                            await updateTokenList(this.api);
                        } catch (err) {
                            setStorage('tradingbots.v4.accountId', prevAccountId);
                            setStorage(AppConstants.STORAGE_ACTIVE_TOKEN, prevActiveToken);
                            // eslint-disable-next-line no-console
                            console.error(err);
                            $.notify((err && err.message) || translate('Account switch failed'), {
                                position : 'bottom left',
                                className: 'error',
                            });
                        } finally {
                            v4AccountSwitchInFlight = false;
                            $('#account-switch-loader').removeClass('visible');
                            $('#main-logout').show();
                        }
                        return;
                    }
                    // Legacy (non-v4) accounts can no longer authorize under Deriv's current
                    // API. Send the user through the working v4 login instead of attempting
                    // a switch that can never succeed.
                    $('#account-switch-loader').removeClass('visible');
                    $.notify(translate('Your session is outdated. Please log in again.'), {
                        position : 'bottom left',
                        className: 'error',
                    });
                    redirectToV4OAuthLogin();
                })
                .catch(() => {});
        });

        // ask first: authorize an existing Deriv account, or go create one
        const derivConnectDialog = new DerivConnectDialog(async () => {
            saveBeforeUnload();
            try {
                await redirectToV4OAuthLogin();
            } catch (err) {
                console.error('[login] OAuth redirect failed:', err);
                $.notify((err && err.message) || translate('Login failed'), {
                    position : 'bottom left',
                    className: 'error',
                });
            }
        });
        $('#loginv2, #toolbox-loginv2').on('click', () => derivConnectDialog.open());

        $('#statement-reality-check').click(() => {
            document.location = `https://www.binary.com/${getLanguage()}/user/statementws.html#no-reality-check`;
        });
        $(document).keydown(e => {
            if (e.which === 189) {
                // Ctrl + -
                if (e.ctrlKey) {
                    this.blockly.zoomOnPlusMinus(false);
                    e.preventDefault();
                }
            } else if (e.which === 187) {
                // Ctrl + +
                if (e.ctrlKey) {
                    this.blockly.zoomOnPlusMinus(true);
                    e.preventDefault();
                }
            }
        });
    }
    stop() {
        if (this.blockly) {
            this.blockly.stop();
        }
    }
    addEventHandlers() {
        const getRunButtonElements = () => document.querySelectorAll('#runButton, #runButtonBottom, #summaryRunButton');
        const getStopButtonElements = () => document.querySelectorAll('#stopButton, #stopButtonBottom, #summaryStopButton');
        window.addEventListener('storage', e => {
            window.onbeforeunload = null;
            // ponytail: AUTOTRADER_STORAGE.SESSION_TOKEN is rewritten on every
            // getAutotraderApiToken() call to mirror Supabase's background autoRefreshToken, so
            // this event can fire from a routine token refresh in another tab, not just explicit
            // login/logout. Don't reload out from under a running bot.
            const botRunning = this.blockly && this.blockly.hasStarted();
            if (e.key === 'activeToken' && e.newValue !== e.oldValue && !botRunning) {
                window.location.reload();
            }
            if (!botRunning && (e.key === AUTOTRADER_STORAGE.SESSION_TOKEN || e.key === AUTOTRADER_STORAGE.SITE_LOGGED || e.key === AUTOTRADER_STORAGE.USER_SNAPSHOT)) {
                window.location.reload();
            }
            if (e.key === 'realityCheckTime') hideRealityCheck();
        });
        // Mobile "tweak and go": a loaded strategy with tunables opens Quick Settings automatically so
        // the trader can set stake/limits and hit Run without editing blocks on a phone.
        globalObserver.register('strategy.loaded', () => {
            const isMobile = window.matchMedia('(max-width: 769px)').matches;
            if (isMobile && scanTunables(Blockly.mainWorkspace).length > 0) {
                quickSettingsDialog.open();
            }
        });

        globalObserver.register('Error', error => {
            getRunButtonElements().forEach(el => {
                const elRunButton = el;
                elRunButton.removeAttribute('disabled');
            });

            if (error.error && error.error.error.code === 'InvalidToken') {
                clearAutotraderSession();
                clearV4Session();
                removeAllTokens();
                updateTokenList();
                this.stop();
            }
        });

        globalObserver.register('bot.running', () => {
            getRunButtonElements().forEach(el => {
                const elRunButton = el;
                elRunButton.style.display = 'none';
                elRunButton.setAttributeNode(document.createAttribute('disabled'));
            });
            getStopButtonElements().forEach(el => {
                const elStopButton = el;
                elStopButton.style.display = 'flex';
                elStopButton.removeAttribute('disabled');
            });
        });

        globalObserver.register('bot.stop', () => {
            // Enable run button, this event is emitted after the interpreter
            // killed the API connection.
            getStopButtonElements().forEach(el => {
                const elStopButton = el;
                elStopButton.style.display = 'none';
                elStopButton.removeAttribute('disabled');
            });
            getRunButtonElements().forEach(el => {
                const elRunButton = el;
                elRunButton.style.display = null;
                elRunButton.removeAttribute('disabled');
            });
        });

        globalObserver.register('bot.info', info => {
            if ('profit' in info) {
                const token = $('.account-id')
                    .first()
                    .attr('value');
                const user = getToken(token);
                globalObserver.emit('log.revenue', {
                    user,
                    profit  : info.profit,
                    contract: info.contract,
                });
            }
        });
    }
    showHeader = show => {
        const $header = $('#header');
        const $topbarAccount = $('#toolbox-account');
        const $toggleHeaderButton = $('.icon-hide-header');
        if (show) {
            $header.show(0);
            $topbarAccount.hide(0);
            $toggleHeaderButton.removeClass('enabled');
        } else {
            $header.hide(0);
            $topbarAccount.show(0);
            $toggleHeaderButton.addClass('enabled');
        }
        setStorage('showHeader', show);
        window.dispatchEvent(new Event('resize'));
    };
}

function initRealityCheck(stopCallback) {
    startRealityCheck(
        null,
        $('.account-id')
            .first()
            .attr('value'),
        stopCallback
    );
}

function renderErrorPage() {
    render.render(<ErrorPage title={translate('Unfortunately, Binary Bot isn’t available in your country')} message={translate('Want to trade CFDs on MT5? You’ll have access to forex, stocks, stock indices, commodities, cryptocurrencies, and synthetics.')} redirectButtonTitle="Go to MT5" redirectButtonURL="https://www.binary.com/en/user/metatrader.html" />, $('#errorArea')[0]);
    document.getElementById('toolbox').remove();
    document.getElementById('blocklyDiv').remove();
    document.getElementById('blocklyArea').remove();
}

function renderReactComponents(api) {
    // ReactDOM.render(<ServerTime api={api} />, $('#server-time')[0]);
    render(<ServerTime api={api} />, $('#server-time')[0]);
    // ReactDOM.render(<Tour />, $('#tour')[0]);
    // ReactDOM.render(
    //     <OfficialVersionWarning
    //         show={
    //             !(typeof window.location !== 'undefined' && isProduction() && window.location.pathname === '/bot.html')
    //         }
    //     />,
    //     $('#footer')[0]
    // );
    document.getElementById('errorArea').remove();
    // ReactDOM.render(<TradeInfoPanel api={api} />, $('#summaryPanel')[0]);
    // ReactDOM.render(<LogTable />, $('#logTable')[0]);
    render(<TradeInfoPanel api={api} />, $('#summaryPanel')[0]);
    render(<LogTable />, $('#logTable')[0]);
}
